import React, { useEffect, useState } from 'react'
import {
    getCountFromServer,
    collection,
    where,
    query,
    getFirestore,
    Timestamp
} from 'firebase/firestore'
import {  useParams } from 'react-router-dom';
import { Gifts } from './cs-connect';
import { usePromotionsContext } from './containers/PromotionsContext';
import CheckPermission from './utils/CheckPermission';
import OpenInBrowser from '@material-ui/icons/OpenInBrowser'
import moment from 'moment';

const firestore = getFirestore()

export default function PromotionDashboard() {

    const { promotionId } = useParams() as { promotionId: string }
    const { fetchPromotion } = usePromotionsContext()
    const ref = query(collection(firestore, 'orders'), where('promotionInfo.id', '==', promotionId))

    const [totalOrders, setTotalOrders] = useState(0)
    const [failedOrders, setFailedOrders] = useState(0)
    const [shippedOrders, setShippedOrders] = useState(0)
    const [openOrders, setOpenOrders] = useState(0)
    const [completedOrders, setCompletedOrders] = useState(0)
    const [cancelledOrders, setCancelledOrders] = useState(0)

    const [products, setProducts] = useState<{
        [id: string] : Gifts.ShopifyProduct & { count: number }
    }>({})

    const [dailyOrders, setDailyOrders] = useState<{
        title: string,
        count: number
    }[]>([])

    useEffect(() => {
        getAnalytics()
    }, [])

    const cardStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        padding: '1em',
        border: '1px solid #ccc',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        fontSize: 22,
        justifyContent: 'center'
    }

    const valueStyle = {
        fontSize: 30,
        fontWeight: 'bold'
    }
    const baseUrl = 'https://admin.infigifts.com/orders?search=promotionInfo.id==';

    return (
        <div style={{ padding: '1em' }}>
            <h2 style={{ marginTop: '2em' }}>By Orders</h2>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1em'
            }}>
                <div style={cardStyle}>
                    <div style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div>Total Orders</div>
                    </div>
                    <p style={valueStyle}>{totalOrders}</p>
                    <CheckPermission minimumRole="admin">
                        <a target='_blank' href={`${baseUrl}${promotionId}`}><OpenInBrowser /></a>
                    </CheckPermission>
                </div>
                <div style={cardStyle}>
                    <div style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div>Failed Orders</div>
                    </div>
                    <p style={valueStyle}>{failedOrders}</p>
                    <CheckPermission minimumRole="admin">
                        <a target='_blank' href={`${baseUrl}${promotionId},status=failed`}><OpenInBrowser /></a>
                    </CheckPermission>
                </div>
                <div style={cardStyle}>
                    <div style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div>Shipped Orders</div>
                    </div>
                    <p style={valueStyle}>{shippedOrders}</p>
                    <CheckPermission minimumRole="admin">
                        <a target='_blank' href={`${baseUrl}${promotionId},status=shipped`}><OpenInBrowser /></a>
                    </CheckPermission>
                </div>
                <div style={cardStyle}>
                    <div style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div>Open Orders</div>
                    </div>
                    <p style={valueStyle}>{openOrders}</p>
                    <CheckPermission minimumRole="admin">
                        <a target='_blank' href={`${baseUrl}${promotionId},status=created`}><OpenInBrowser /></a>
                    </CheckPermission>
                </div>
                <div style={cardStyle}>
                    <div style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div>Completed Orders</div>
                    </div>
                    <p style={valueStyle}>{completedOrders}</p>
                    <CheckPermission minimumRole="admin">
                        <a target='_blank' href={`${baseUrl}${promotionId},status=completed`}><OpenInBrowser /></a>
                    </CheckPermission>
                </div>
                <div style={cardStyle}>
                    <div style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div>Cancelled Orders</div>
                    </div>
                    <p style={valueStyle}>{cancelledOrders}</p>
                    <CheckPermission minimumRole="admin">
                        <a target='_blank' href={`${baseUrl}${promotionId},status=cancelled`}><OpenInBrowser /></a>
                    </CheckPermission>
                </div>
            </div>
            <h2 style={{ marginTop: '2em' }}>By Products</h2>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '1.5em'
            }}>
                {Object.values(products)
                    .sort((a, b) => b.count - a.count) // Sort products by count in descending order
                    .map(product => (
                        <div key={product.id} style={{
                            ...cardStyle,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '1.5em 0'
                        }}>
                            <img 
                                src={product.image.src} 
                                alt={product.title} 
                                style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1em' }} 
                            />
                            <div style={{ marginBottom: '0.1em', fontSize: '1em', textAlign: 'center' }}>{product.title}</div>
                            <div style={valueStyle}>{product.count}</div>
                        </div>
                    ))}
            </div>
            <h2 style={{ marginTop: '2em' }}>Daily Orders</h2>
            {dailyOrders.length > 0 && <div style={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: '1em',
                padding: '1em',
                border: '1px solid #ccc',
                width: '98%', // Dynamically set width based on array length,
                overflowX: 'scroll'
            }}>
                {dailyOrders.map((month, index) => {
                    const maxCount = Math.max(...dailyOrders.map(m => m.count));
                    const barHeight = maxCount > 0 ? (month.count / maxCount) * 200 : 0; // Normalize height based on max count
                    return (
                        <div key={index} style={{ textAlign: 'center', width: '100px', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <div style={{ fontSize: '1.1em', color: '#555' }}>{month.count}</div>
                            <div style={{
                                height: `${Math.max(barHeight, 1)}px`,
                                width: '8px',
                                backgroundColor: '#4caf50',
                                borderRadius: '4px',
                                marginBottom: '0.5em'
                            }}></div>
                            <div>{month.title}</div>
                        </div>
                    );
                })}
            </div>}
        </div>
    )

    async function getAnalytics() {
        try {

            const [
                totalOrdersQuery,
                failedOrdersQuery,
                shippedOrdersQuery,
                cancelledOrdersQuery,
                openOrdersQuery,
                completedOrdersQuery
            ] = await Promise.all([
                getCountFromServer(query(ref)),
                getCountFromServer(query(ref, where('status', '==', 'failed'))),
                getCountFromServer(query(ref, where('status', '==', 'shipped'))),
                getCountFromServer(query(ref, where('status', '==', 'cancelled'))),
                getCountFromServer(query(ref, where('status', '==', 'created'))),
                getCountFromServer(query(ref, where('status', '==', 'completed'))),
                getProductAnalytics(),
                getMonthlyOrders()
            ])

            setTotalOrders(totalOrdersQuery.data().count)
            setFailedOrders(failedOrdersQuery.data().count)
            setShippedOrders(shippedOrdersQuery.data().count)
            setCancelledOrders(cancelledOrdersQuery.data().count)
            setOpenOrders(openOrdersQuery.data().count)
            setCompletedOrders(completedOrdersQuery.data().count)
            
        } catch (error) {
            console.error('Error fetching analytics:', error)
        }
    }

    async function getProductAnalytics() {
        const response = await fetchPromotion(promotionId)

        const productsResponse = await Gifts.getGiftsWithProductIds(response?.productIds ?? [], true)
        const productsWithCounts = await Promise.all(
            productsResponse.map(async (product) => {
                const productCountQuery = await getCountFromServer(
                    query(ref, where('product.id', '==', product.id))
                )
                return {
                    ...product,
                    count: productCountQuery.data().count
                }
            })
        )

        setProducts(
            productsWithCounts.reduce((acc, product) => {
                acc[product.id] = product
                return acc
            }, {} as { [id: string]: Gifts.ShopifyProduct & { count: number } })
        )
    }

    async function getMonthlyOrders() {
        try {
            const response = await fetchPromotion(promotionId)
            const startDateTimestamp = response?.startDate as Timestamp
            const endDateTimestamp = response?.endDate as Timestamp
            const startDate = startDateTimestamp.toDate()
            const endDate = endDateTimestamp.toDate()

            const dailyCounts: { count: number; title: string }[] = []

            for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
            const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
            const dayEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)

            // console.log('dayStart', dayStart.toString(), dayEnd.toString())

            const dailyCountQuery = await getCountFromServer(query(ref, where('createdAt', '>=', dayStart), where('createdAt', '<=', dayEnd)))

            dailyCounts.push({
                count: dailyCountQuery.data().count,
                title: moment(dayStart).format('MMM DD')
            })
            }

            setDailyOrders(dailyCounts)

        } catch (error) {
            console.log('Failed to get monthly orders', error)
        }

    }
}
